import React from "react";
import { Button, Modal } from "react-bootstrap";

const TITLE_ID = "teacher-reports-metrics-confirmation-title";

export const GenerateReportConfirmation = ({ show, onCancel, onConfirm }) => (
  <Modal show={show} onHide={onCancel} centered aria-labelledby={TITLE_ID}>
    <Modal.Header>
      <Modal.Title id={TITLE_ID}>Generate a new report?</Modal.Title>
    </Modal.Header>
    <Modal.Body>This session already has a report. Generating a new one replaces it.</Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Generate report
      </Button>
    </Modal.Footer>
  </Modal>
);
